<template>
  <vs-popup class="view-raw-material-waste-pop-up"
            title="VIEW RAW MATERIAL WASTE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <div id="raw-material-stock-popup" class="vx-row">
        <div class="vx-col lg:w-full w-full">
          <vs-table noDataText="">
            <template>
              <vs-tr>
                <vs-td class="font-semibold">WORK ORDER</vs-td>
                <vs-td>{{ ram_waste_item.work_order || ''}}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="font-semibold">QUANTITY (KG)</vs-td>
                <vs-td>{{ toFixed(ram_waste_item.quantity)}}</vs-td>
              </vs-tr>

            </template>
          </vs-table>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-table
            id="view-rm-waste-pop-up-table"
            :data="ram_waste_item.raw_materials"
            stripe class="table-dark-inverted table-auto vs-con-loading__container">

            <template slot="thead">
              <vs-th width="25%"  class="text-sm">ITS PROD CODE</vs-th>
              <vs-th width="25%"  class="text-sm">QUANTITY (KG)</vs-th>
              <vs-th width="25%" class="text-sm">STATUS</vs-th>
              <vs-th width="25%" class="text-sm">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr class="text-md" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

<!--                <vs-td v-if="!data[indextr].linked_work_order.work_order_code">-->

<!--                </vs-td>-->

                <vs-td class="cursor-pointer text-primary" :data="data[indextr].work_order">
                  <vx-tooltip :text="'View ' + data[indextr].work_order" position="right">
                    <a @click.stop="onClickWorkOrder(data[indextr].work_order_id)">{{ data[indextr].raw_material}}</a>
                  </vx-tooltip>
                </vs-td>

                <vs-td :data="data[indextr].quantity">
                  {{ toFixed(data[indextr].quantity)}}
                </vs-td>

                <vs-td class="text-primary" :data="data[indextr].status">
                  {{ data[indextr].status}}
                </vs-td>

                <vs-td >
                  <div class="vx-row">
                    <vx-tooltip v-if="data[indextr].status !== 'Added to Work Order'" text="Update Rm Waste" position="top">
                      <vs-button class="ml-3"
                                 @click.stop="onCLickRmWasteUpdate(data[indextr])"
                                 size="small" color="warning" type="filled" icon-pack="feather" icon="icon-edit"></vs-button>
                    </vx-tooltip>
                    <!-- <vx-tooltip v-if="data[indextr].status !== 'Added to Work Order'" text="return to RM inventory" position="top">
                      <vs-button class="ml-3"
                                 @click.stop="onCLickRmWasteRemove(data[indextr].id)"
                                 size="small" color="danger" type="filled" icon-pack="feather" icon="icon-delete"></vs-button>
                    </vx-tooltip> -->
                  </div>
                </vs-td>

                <template class="expand-user" slot="expand">
                  <div class="con-expand-users w-1/2" v-if="data[indextr].linked_work_order.work_order_code">
                    <vs-list>
                      <vs-list-item class="cursor-pointer" :title="data[indextr].linked_work_order.work_order_code || 'N/A'" subtitle="Reallocated WO"></vs-list-item>
                    </vs-list>
                    <div class="flex">
                      <vs-button @click="onCLickWorkOrderView(data[indextr].linked_work_order.id)" type="border" size="small" icon-pack="feather" icon="icon-eye" class="mr-0 ml-2">View Work Order</vs-button>
                    </div>
                  </div>
                  <div class="con-expand-users w-1/2" v-else>Reallocated WO - N/A</div>
                </template>

              </vs-tr>
            </template>


          </vs-table>
        </div>
      </div>

    </vx-card>
    <vs-popup title="UPDATE RAW MATERIAL WASTE QUANTITY" :active.sync="updatePopUpActive">
      <div class="vx-row mb-3">
        <div class="vx-col md:w-full w-full md:mb-0">
            <small class="label">Quantity (KG)</small>
            <vs-input v-model="update_payload.quantity"  name="quantity" class="w-full" label="" />
        </div>
      </div>

      <div class="flex flex-wrap items-center justify-end mt-8">
        <vs-button id="save_change_button" @click="onCLickRawMaterialWasteUpdate()" class="ml-auto mt-2">Save Changes</vs-button>
        <vs-button @click="updatePopUpActive = false" class="ml-4 mt-2" type="border" color="warning">Close</vs-button>
      </div>

    </vs-popup>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const InventoryRepository = RepositoryFactory.get('inventory')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      updatePopUpActive: false,
      id: '',
      ram_waste_item: {
        work_order: '',
        quantity: '',
        status: ''
      },
      update_payload: {
        id: '',
        quantity: '',
      },
    }
  }

export default {
  name: 'ViewRawMaterialWastePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (data) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = data.id
        this.open = true
        await this.getRawMaterialWaste()
      } catch (error) {

      }
    },
    onCLickRmWasteUpdate(data) {
      this.update_payload.id = data.id
      this.update_payload.quantity = data.quantity
      this.updatePopUpActive = true
    },
    async onCLickRmWasteRemove(id) {
      try {
        await InventoryRepository.removeRawMaterialWaste({rm_waste_ids: [id]})
        this.showSuccessMessage('RM waste returned to the inventory')
        this.open = false
        await this.$parent.refreshData()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    onCLickWorkOrderView(id) {
      this.open = false
      this.$router.push({path: `/pages/manufacturing/work-orders/${id}/details`})
    },

    async onCLickRawMaterialWasteUpdate (){
      const vue = this
      await this.$vs.loading({
        container: '#save_change_button',
        scale: 0.45
      })
       try {
        const payload = { quantity: Number(this.update_payload.quantity ).toFixed(4)}
         await InventoryRepository.updateRawMaterialWaste(this.update_payload.id, payload)
         this.showSuccessMessage('Rm waste updated successfully')
         this.updatePopUpActive = false;
         this.$vs.loading.close('#save_change_button > .con-vs-loading')
         await this.getRawMaterialWaste()
         await this.$parent.fetchRawMaterialWasteItemList()
       }catch (e) {
         this.$vs.loading.close('#save_change_button > .con-vs-loading')
         this.convertAndNotifyError(e)
       }
    },
    async getRawMaterialWaste (){
      const vue = this
      await this.$vs.loading({
        container: '#view-rm-waste-pop-up-table',
        scala: 0.45
      })
       try {
         this.ram_waste_item = []
         const { data } = (await InventoryRepository.getRawMaterialWaste(this.id)).data
         this.ram_waste_item = data
         this.$vs.loading.close('#view-rm-waste-pop-up-table > .con-vs-loading')
       }catch (e) {
         this.$vs.loading.close('#view-rm-waste-pop-up-table > .con-vs-loading')
         this.convertAndNotifyError(e)
       }
    },
    toFixed(number) {
      return Number(number).toFixed(4)
    }

  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .view-raw-material-waste-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }
  .vs-tooltip { z-index: 99999 !important; }

</style>
